import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG } from 'src/app/shared/configurations/configurations.factory';
import { Configurations } from 'src/app/shared/configurations/models/configurations.model';
import { AssetsCachedHttpClientService } from 'src/app/shared/utils/services/asset-cached-http-client.service';

@Injectable({
  providedIn: 'root'
})
export class ConsulenteProxyService {

  private readonly baseUrl: string

  constructor(@Inject(APP_CONFIG) config: Configurations, private readonly httpClient: AssetsCachedHttpClientService) {
    this.baseUrl = config.environmentConfig.portoSecureApiBaseUrl + '/api/v2/consulente'
  }

  getConsulenteIcon(idConsulente: number, size: number = 90, background: string | undefined = undefined, ellipse: boolean = true) {
    let query: string = '';

    if (background) query = query + `${query ? '&' : ''}background=${background}`
    if (ellipse) query = query + `${query ? '&' : ''}ellipse=${ellipse}`

    return this.httpClient.get(this.baseUrl + `/${idConsulente}` + '/ico' + `/${size}` + `${query ? '?' + query : ''}`)
  }
}
